// extracted by mini-css-extract-plugin
export default {"section":"sections_section__Rs7LH","label":"sections_label__tU6Hr"};